import React, { type HTMLAttributes } from 'react'

import { TruncatedTextWithTooltip } from 'components/common/TruncatedTextWithTooltip'
import { TestSuiteScenarioInfo } from 'components/test-suites/forms/test-suite-composition/TestSuiteScenarioInfo'

import type { AutocompleteRenderGroupParams } from '@mui/material/Autocomplete/Autocomplete'
import type { TestSuiteScenarioOption } from 'components/test-suites/forms/test-suite-composition/test-suite-composition-utils'

export const TestSuiteScenarioSearchOption = React.forwardRef<
  HTMLLIElement,
  {
    option: TestSuiteScenarioOption
    props: HTMLAttributes<HTMLLIElement>
  } & AutocompleteRenderGroupParams
>(({ option, props, ...rest }, ref) => {
  const label = option.label ?? '""'

  // The "rest" values contain MUI's internal props from the Autocomplete component and are necessary for proper
  // rendering of grouped options.
  return (
    <li {...props} {...rest} key={option.guid} ref={ref}>
      <TruncatedTextWithTooltip
        tooltipProps={{
          title: (
            <TestSuiteScenarioInfo
              id={option.guid}
              owningTeamLabel={option.owningTeamLabel ?? undefined}
            />
          )
        }}
      >
        {label}
      </TruncatedTextWithTooltip>
    </li>
  )
})
